import React, { useState, useEffect } from "react";

const Day = ({ day, onHandleData, resetBtn }) => {
  // const [startTime, setStartTime] = useState("");
  // const [startAMPM, setStartAMPM] = useState("am");
  // const [endTime, setEndTime] = useState("");
  // const [endAMPM, setEndAMPM] = useState("pm");
  // const [breakTime, setBreakTime] = useState("00:00");
  // const [result, setResult] = useState("")

  const [hours, setHours] = useState({
    startTime: "",
    startAMPM: "am",
    endTime: "",
    endAMPM: "pm",
    breakTime: "00:00",
    result: ""
  })


  // handle input changes 
  const handleChange = (tags) => (event) => {
    const inputValue = event.target.value;
    let newValue = inputValue;

    if (inputValue.includes(":")) {
      newValue = inputValue.replace(/:/g, "");
    }

    if (newValue.length > 2) {
      newValue = `${newValue.slice(0, 2)}:${newValue.slice(2)}`;
    }

    if (newValue.length >= 2 && newValue.charAt(0) > 1) {
      newValue = `0${newValue}`;
    }

    if (newValue.length >= 3 && newValue.slice(0, 2) > 12) {
      newValue = `12${newValue.slice(2)}`;
    }

    if (newValue.length === 5 && newValue.slice(3) > 59) {
      newValue = `${newValue.slice(0, 3)}00`;
    }

    if (tags === "start-time") {
      setHours(prev => ({ ...prev, startTime: newValue }))
    }
    if (tags === "end-time") {
      setHours(prev => ({ ...prev, endTime: newValue }))
    }
    if (tags === "break-time") {
      setHours(prev => ({ ...prev, breakTime: newValue }))
    }
  };

  useEffect(() => {
    
    
      
      const [startHours, startMinutes] = hours?.startTime?.split(':')?.map(Number);
      const [endHours, endMinutes] = hours?.endTime?.split(':')?.map(Number);
      const [breakHours, breakMinutes] = hours?.breakTime?.split(':')?.map(Number);

      
      let hours_var = endHours - startHours;
      let minutes = endMinutes - startMinutes;
      if (hours.startAMPM === 'pm') hours_var += 12;
      if (hours.endAMPM === 'pm') hours_var += 12;
      
      if (minutes < 0) {
        minutes += 60;
        hours_var -= 1;
      }
      

      const totalMinutes = hours_var * 60 + minutes - (breakHours * 60 + breakMinutes);
      const totalHours = Math.floor(totalMinutes / 60);
      const remainingMinutes = totalMinutes % 60;

      // console.log(totalHours, " ", remainingMinutes)
      const formattedResult = `${totalHours}:${remainingMinutes.toString().padStart(2, '0')}`;
      setHours(prev => ({ ...prev, result: formattedResult }))
      // setResult(formattedResult)
      if (formattedResult !== "NaN:NaN") {
        onHandleData(day, formattedResult);
      }
      else {
        onHandleData(day, "00:00");
      }
    
  }, [hours.startTime, hours.startAMPM, hours.endTime, hours.endAMPM, hours.breakTime, day]);


  useEffect(() => {
    if (resetBtn === true) {
      setHours({
        startTime: "",
        statrAMPM: "am",
        endTime: "",
        endAMPM: "pm",
        breakTime: "",
        result: "00:00"
      })
    }
  }, [resetBtn])

  return (
    <form className="flex justify-between items-center text-[13px] font-medium text-gray-500 w-full pb-[10px]">
      <div className="w-[56px] text-gray-700">{day}</div>
      <div className="flex flex-col md:flex-row w-[154px] justify-center">
        <input
          style={{ width: "65px", outline: "none" }}
          className="rounded-md border text-gray-500 outline-none py-2 px-3 w-[65px] mr-2"
          id="start-time"
          name="start-time"
          type="text"
          placeholder="00:00"
          maxLength={5}
          required
          value={hours.startTime}
          onChange={handleChange("start-time")}
        />
        <select
          style={{ width: "45px", outline: "none" }}
          className="border outline-none rounded-md w-[45px]"
          id="start-ampm"
          name="start-ampm"
          required
          value={hours.startAMPM}
          onChange={(e) => setHours(prev => ({ ...prev, startAMPM: e.target.value }))}
        >
          <option value="am">AM</option>
          <option value="pm">PM</option>
        </select>
      </div>
      <div className="flex flex-col md:flex-row w-[154px]">
        <input
          style={{ width: "65px", outline: "none" }}
          className="border text-gray-400 outline-none rounded-md py-2 px-3 w-[65px] mr-2"
          id="end-time"
          name="end-time"
          type="text"
          placeholder="00:00"
          maxLength={5}
          required
          value={hours.endTime}
          onChange={handleChange("end-time")}
        />
        <select
          style={{ width: "45px", outline: "none" }}
          className="border outline-none rounded-md w-[45px]"
          id="end-ampm"
          name="end-ampm"
          required
          value={hours.endAMPM}
          onChange={(e) => setHours(prev => ({ ...prev, endAMPM: e.target.value }))}
        >
          <option value="pm">PM</option>
          <option value="am">AM</option>
        </select>
      </div>
      <div className="w-[91px]">
        <input
          style={{ width: "65px", outline: "none" }}
          className="border rounded-md py-2 px-3 w-[65px] mr-2"
          id="start-time"
          name="break-time"
          type="text"
          placeholder="00:00"
          maxLength={5}
          required
          value={hours.breakTime}
          onChange={handleChange("break-time")}
        />
      </div>
      <div className="w-[67px] flex items-center justify-center">
        <span className="">{hours.result === "NaN:NaN" ? "00:00" : hours.result}</span>
      </div>
    </form>
  );
};

export default Day;
